import api from "../api/api";
import ISavedView, {
    ISavedViewCreateRequest,
    ISavedViewResponseModel,
    ISavedViewUpdateRequest
} from "../interfaces/ISavedView";

export default class SavedViewsApiService {
    public async getSavedViews(): Promise<ISavedView[]> {
        const response = await api.get<ISavedViewResponseModel[]>("/savedView/get");
        return this.mapResponseModelsToSavedViews(response.data);
    }

    public async createSavedView(request: ISavedViewCreateRequest): Promise<ISavedView> {
        const response = await api.post<ISavedViewResponseModel>("/savedView/create", request);
        return this.mapResponseModelToSavedView(response.data);
    }

    public async updateSavedView(request: ISavedViewUpdateRequest): Promise<ISavedView> {
        const response = await api.post<ISavedViewResponseModel>("/savedView/update", request);
        return this.mapResponseModelToSavedView(response.data);
    }

    public async deleteSavedView(id: number): Promise<void> {
        await api.delete(`/savedView/delete?id=${id}`);
    }

    private mapResponseModelsToSavedViews(views: ISavedViewResponseModel[]): ISavedView[] {
        return views.map(sv => this.mapResponseModelToSavedView(sv));
    }

    private mapResponseModelToSavedView(sv: ISavedViewResponseModel): ISavedView {
        return {
            id: sv.id,
            name: sv.name,
            isShared: sv.isShared,
            viewState: JSON.parse(sv.viewStateJson),
            modifiedDate: new Date(sv.modifiedDate),
            createdByUser: sv.createdByUser,
            modifiedByUser: sv.modifiedByUser,
        };
    }
}
